/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */


/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/synbiz_globus_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Autoplay])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

});

var swiper = new Swiper(".home-section_5-swiper", {
	direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 2,
 navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
		loop: true,
		speed: 5000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 6,
				spaceBetween: 30,
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

  var swiper = new Swiper(".about-single-section_2-swiper", {
	slidesPerView: 1,
	pagination: {
	  el: ".swiper-pagination",
	  clickable: true,
	},
	
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		1024: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
		1200: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 30,
			// freeMode: {
			// 	enabled: true,
			// 	sticky: true,
			// },
		}
	},
  });



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */

 /*  ------------------ GOOGLE MEET FUNCTION - START -------------------- */

// document.getElementById('calendarButton').onload = function() {
	
// 	calendar.schedulingButton.load({
// 		url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1g8SGGLdagwD-EVu5mBmWg4NtqGiXAMVgRwaCkru8JvFkOV-mqqhiRGwkG0FSCQAdcjdo3Cs8E?gv=true',
// 		color: '#000000',
// 		label: 'Schedule A Call',
// 		target: document.getElementById('calendarButton') // target the button
// 	})
// };


// window.addEventListener('load', function() {
// 	// Attach the click event listener to the existing button
// 	document.getElementById('calendarButton').onclick = function() {
// 		calendar.schedulingButton.load({
// 			url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1g8SGGLdagwD-EVu5mBmWg4NtqGiXAMVgRwaCkru8JvFkOV-mqqhiRGwkG0FSCQAdcjdo3Cs8E?gv=true',
// 			color: '#039BE5',
// 			label: 'Schedule A Call',
// 			target: document.getElementById('calendarButton') // Use the existing button as the target
// 		});
// 	};
// });
  /*  ------------------ GOOGLE MEET FUNCTION - END -------------------- */

